import React, { useState, useEffect, useCallback } from 'react';
import { Form } from 'react-bootstrap';
import api from '../../services/api';
import useAuth from '../../hooks/useAuth';
// import APP_CONFIG from '../../config/appConfig';
import { Link } from 'react-router-dom';
import ConfirmDialog from '../HtmlElements/ConfirmDialog';
import './Companies.css';
import { useConfig } from '../../context/AppConfigContext';
import ScreenLoader from '../HtmlElements/ScreenLoader';
import Alert from '../HtmlElements/Alert';
import { useUser } from '../../context/UserContext';
import ActionDropdown from '../HtmlElements/ActionDropdown';
import SubmitActionButton from '../HtmlElements/SubmitActionButton';
import ActionCheckbox from '../HtmlElements/ActionCheckbox';

const Companies = () => {
  useAuth(); // Ensure the user is authenticated
  const { user } = useUser();
  const current_role_key = user?.role_key;
  const [success_message, setSuccessMessage] = useState('');
  const [loader, setLoader] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);
  const [sortField, setSortField] = useState('company_name');
  const [sortOrder, setSortOrder] = useState('asc');
  const [filter, setFilter] = useState({ companyname: '',  account_type: '', is_deleted:0, is_active: '' });

  const [showConfirm, setShowConfirm] = useState(false);
  const [companyToDelete, setCompanyToDelete] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [showArchive, setShowArchive] = useState(0);

  const [action, setAction] = useState({action: ''});
  const [checkedItems, setCheckedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [updateDataStatus, setupdateDataStatus] = useState(false);

  const {appConfig} = useConfig();

  const fetchCompanies = useCallback(async () => {
    setLoader(true);
    try {

      if(filter.is_active === ""){
        delete(filter.is_active)
      }

      const filterData = { 
        "id": '', 
        // "is_deleted": 0, 
        page: currentPage,
        limit: perPage,
        sort_by: sortField,
        order: sortOrder,
        ...filter,
      };

      const response = await api.get('/companies/get_companies', { "params": filterData });
      let companies = [...response.data.result.list];

      setCompanies(companies);

      setTotalPages(Math.ceil(response.data.result.total / perPage));
  
    } catch (err) {
      setError(err.message || 'Failed to fetch companies');
    }
    setLoader(false);
  }, [currentPage, perPage, sortField, sortOrder, filter, updateDataStatus]);
  

  useEffect(() => {
    let successMessage = sessionStorage.getItem('successMessage');
    if (successMessage) {
      setSuccessMessage(successMessage);
      sessionStorage.removeItem('successMessage'); // Clear the message
    }
    fetchCompanies();
  }, [fetchCompanies]);

  useEffect(() => {
    if(checkedItems.length > 0 && checkedItems.length === companies.length){
      setSelectAll(true);
    }else{
      setSelectAll(false);
    }
  }, [checkedItems])

  const [users, setUsers] = useState([]);

  const fetchUsers = async () => {
    setLoader(true);
    try {
      const filterData = { 'is_active': 1, is_deleted: 0, limit: 1000 };
      const response = await api.get('/users/get_users_list', { params: filterData });
      const allUsers = response.data.result.list.map(user => ({
        ...user,
        display_name: `${user.firstname} ${user.lastname}`,
      }));
      setUsers(allUsers); // Store all users
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchUsers(); // Fetch users on component mount
  }, []);  

  const handleDelete = async () => {
    setLoader(true);
    try {
      await api.delete(`/companies/delete_company/${companyToDelete}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`
        }
      });
      setSuccessMessage("Company Deleted Successfully...");
      hideDeleteConfirm();
      setCompanies((prevCompanies) => prevCompanies.filter(company => company.id !== companyToDelete));
    } catch (error) {
      console.error('Error deleting company:', error);
    }
    setLoader(false);
  };
  
  const showDeleteConfirm = (companyId) => {
    setCompanyToDelete(companyId);
    setShowConfirm(true);
  };

  const hideDeleteConfirm = () => {
    setShowConfirm(false);
    setCompanyToDelete(null);
  };

  const handleSort = (field) => {
    const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortOrder(order);
  };

  const showArchived = (e) => {
    setCurrentPage(1);
    //alert(e.target.value);   
      //let temp = document.getElementById("archived");*/
    let temp = e.target;
    if (temp.value === 0) {
      //temp.value = 1;
      e.target.value = 1;
      setFilter({ ...filter, [e.target.name]: e.target.value });
    } else {
      //temp.value = 0;
      e.target.value = 0;
      setFilter({ ...filter, [e.target.name]: e.target.value });
    }
    setShowArchive(temp.value);
  };

  const handleFilterChange = (e) => {
    setCurrentPage(1);    
    // let selectfilter = e.target;
    /*delete filter.is_deleted;
    delete filter.is_active;*/       
    // if (selectfilter.name === 'is_active' && selectfilter.value === 0) {
    //   delete filter.is_deleted
    //   e.target.name = "is_active";
    //   e.target.value = 0;
    //   alert('inactive 0');      
    // } else if (selectfilter.name === 'is_active' && selectfilter.value === 1) {
    //   e.target.name = "is_active";
    //   e.target.value = 1;
    // } else if (selectfilter.name === 'is_deleted' && selectfilter.value === 0) {
    //   e.target.name = "is_deleted";
    //   e.target.value = 1;
    // } else if (selectfilter.name === 'is_deleted' && selectfilter.value === 1) {
    //   e.target.name = "is_deleted";
    //   e.target.value = 0;
    // }    
    setFilter({ ...filter, [e.target.name]: e.target.value });
  };

  const handleFirstPage = () => {
    setCurrentPage(1);
    setSelectAll(false);
    setCheckedItems([]);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
    setSelectAll(false);
    setCheckedItems([]);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
    setSelectAll(false);
    setCheckedItems([]);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    setSelectAll(false);
    setCheckedItems([]);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setSelectAll(false);
    setCheckedItems([]);
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  if(!appConfig){
    return <div></div>;
  }

  const accountTypes = appConfig.account_types;
  const renderAccountManagers = (accountManagers) => {
    return users
      .filter(user => accountManagers.includes(user.id)) // Filter based on account manager IDs
      .map(user => user.display_name)
      .join(' | '); // Join names with separator
  };
  if(current_role_key === undefined){
    return <></>
  }
  if(current_role_key === 'CLIENT'){
    // navigate('/user_profile/profile');
    window.location.replace('/user_profile/profile');
  } else if(current_role_key === 'ANALYST') {
    // navigate('/dashboard');
    window.location.replace('users/user_dashboard');
  }
  return (
    <div className="add_company_wrapper">
      { loader === true && (<ScreenLoader/>) }
      <div className="container-fluid mt-3 p-4">

      {success_message && <Alert type="success" message={success_message} />}
      {error && <Alert type="danger" message={error} /> }      
      
      <div className='row'>
        <div className='col-md-9'>
          <h4 className="blue add_user_heading">Client List</h4>
        </div>
        <div className="col-md-3 align-right pb-3">
          <Link className="add_account_btn" to="/companies/add_company">
          <i className="fa fa-plus" aria-hidden="true"></i> Add Client
          </Link>
        </div>
      </div>

      <div className="row mb-3 mt-4">
      <div className='col-md-9'>
      <div className='left_filter'>
      <div className='admin_filter_head'>

      <h5 className=''>Filter</h5>
      </div>
              <div className="row">


        <div className="col">
          <Form.Control
            className="custom_form_control"
            as="select"
            key="sel-acc-type"
            name="account_type"
            value={filter.account_type}
            onChange={handleFilterChange}>
            <option key="select-otion-acc-type" value="">Select Account Type</option>
            {Object.keys(accountTypes).map((key) => (
              <option key={`acc-type-option-${key}`} value={key}>{accountTypes[key]}</option>
            ))}
          </Form.Control>
        </div>
        <div className="col">
          <input
            type="text"
            className="form-control custom_form_control"
            placeholder="Filter by Company Name"
            key="txt-company-name"
            name="companyname"
            autoComplete="Off"
            value={filter.companyname}
            onChange={handleFilterChange}/>
        </div>
        <div className="col search_filter_user">
            <select
              className="custom_form_control form-control"
              as="select"
              id="selectfilter"
              name="is_active"
              value={filter.is_active}
              onChange={handleFilterChange}
            >             
              <option key="" value="">
                Select Filter
              </option>
              <option key="0" value="0">
                Inactive
              </option>
              <option key="1" value="1">
                Active
              </option>              
            </select>
          </div>
          <div className="col show_archived">
            <input
              id="archived"
              type="checkbox"
              className="form-check-input custom_input_type"
              placeholder="Filter by Email"
              name="is_deleted"
              value={filter.is_deleted}
              onClick={showArchived}
            /> <label className="form-check-label custom_lable_type" htmlFor="archived">Archived</label>
          </div>
          </div>
          </div>
      </div>
      <div className="col-md-3">
      <div className='right_action'>
      <div className='admin_filter_head'>

      <h5 className=''>Actions</h5>
      </div>
      <div className='row'>

         

          <ActionDropdown page="clients" action={action.action} setAction={setAction} />
          <SubmitActionButton
            page = 'companies'
            checkedItems = {checkedItems}
            setCheckedItems = {setCheckedItems}
            action = {action.action}
            currentPage = {currentPage}
            setSelectAll = {setSelectAll}
            setupdateDataStatus = {setupdateDataStatus}
            setSuccessMessage = {setSuccessMessage}
            setCurrentPage = {setCurrentPage}
            setLoader = {setLoader}
            setAction = {setAction}
          />
      </div>
      </div>
      </div>
      </div>
      <div className='table-responsive'>
      <table className="table table-striped font14 table-bordered">
        <thead>
          <tr className="cursor_p">
            <th>
              {/* <input
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAll}
              /> */}
              <ActionCheckbox
                page = 'companies'
                companies = {companies}
                checkedItems = {checkedItems}
                setCheckedItems = {setCheckedItems}
                selectAll = {selectAll}
                setSelectAll = {setSelectAll}
              />
            </th>
            <th onClick={() => handleSort('company_name')} style={{whiteSpace: 'nowrap'}}>
              Client Name {sortField === 'company_name' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>
            <th onClick={() => handleSort('account_type')} style={{whiteSpace: 'nowrap'}}>
              Account Type {sortField === 'account_type' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>
            <th 
             // onClick={() => handleSort('accountmanager')}
             style={{whiteSpace: 'nowrap'}}
            >
              Account Manager {sortField === 'accountmanager' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>
            {/* <th onClick={() => handleSort('subscription_start_date')}>
              Start Date {sortField === 'subscription_start_date' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>
            <th onClick={() => handleSort('subscription_end_date')}>
              End Date {sortField === 'subscription_end_date' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th> */}
            {/* <th onClick={() => handleSort('numberOfUsers')}>
              Users Created {sortField === 'numberOfUsers' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th> */}
            <th onClick={() => handleSort('numberOfClientAdmin')} style={{whiteSpace: 'nowrap'}}>
              Client Admins {sortField === 'numberOfClientAdmin' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>
            <th onClick={() => handleSort('numberOfClientEmployee')} style={{whiteSpace: 'nowrap'}}>
              Client Employees {sortField === 'numberOfClientEmployee' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>

            <th onClick={() => handleSort('numberOfDemoUsers')} style={{whiteSpace: 'nowrap'}}>
              Demo Users {sortField === 'numberOfDemoUsers' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>
            <th onClick={() => handleSort('numberOfTrialUsers')} style={{whiteSpace: 'nowrap'}}>
              Trial Users {sortField === 'numberOfTrialUsers' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>
            <th onClick={() => handleSort('numberOfLiveUsers')} style={{whiteSpace: 'nowrap'}}>
              Live Users {sortField === 'numberOfLiveUsers' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>

            <th onClick={() => handleSort('numberOfAccounts')} style={{whiteSpace: 'nowrap'}}>
              Accounts {sortField === 'numberOfAccounts' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>
            <th onClick={() => handleSort('company_wise_user_mau')}>
              MAU {sortField === 'company_wise_user_mau' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>
            <th onClick={() => handleSort('company_wise_user_dau')}>
              DAU {sortField === 'company_wise_user_dau' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>
            <th onClick={() => handleSort('is_active')} style={{whiteSpace: 'nowrap'}}>
              Is Active {sortField === 'is_active' && (sortOrder === 'asc' ? '▲' : '▼')}
            </th>
            { showArchive !== 1 && (<th>Action</th>)}
          </tr>
        </thead>
        <tbody>
          {companies.map((company, index) => {
            return (<tr key={`company-list-${company.id}`}>
              <td>
                {/* <input
                  type="checkbox"
                  checked={checkedItems.includes(company.id)}
                  onChange={() => handleCheckboxChange(company.id)}
                /> */}
                <ActionCheckbox
                  page = 'companies'
                  checkedItems = {checkedItems}
                  setCheckedItems = {setCheckedItems}
                  related_id = {company.id}
                />
              </td>
              <td>{company.company_name}</td>
              <td>{accountTypes[company.account_type]}</td>
              <td>{renderAccountManagers(company.account_managers)}</td>
              {/* <td>{company.subscription_start_date}</td>
              <td>{company.subscription_end_date}</td> */}
              {/* <td>{company.numberOfUsers}</td> */}
              <td>{company.numberOfClientAdmin}</td>
              <td>{company.numberOfClientEmployee}</td>
              
              <td>{company.numberOfDemoUsers}</td>
              <td>{company.numberOfTrialUsers}</td>
              <td>{company.numberOfLiveUsers}</td>

              <td>{company.numberOfAccounts}</td>
              <td>{company?.company_wise_user_mau} {' '}
                {company?.company_wise_user_mau_percent ? (<>({company?.company_wise_user_mau_percent}%)</>) : '' }
              </td>
              <td>
                {company?.company_wise_user_dau} {' '}
                {company?.company_wise_user_dau_percent ? (<>({company?.company_wise_user_dau_percent}%)</>) : '' }
              </td>
              <td>{company.is_active === 1 ? 'Yes' : 'No'}</td>
              { showArchive !== 1 && (<td>
                <Link to={`/companies/edit_company/${company.id}`} className="edit_right_margin cursor_p">
                  <span><i className="fa fa-edit blue"></i></span>
                </Link>
                <span
                  onClick={() => showDeleteConfirm(company.id)}
                  className="cursor_p">
                  <i className="fa fa-trash"></i>
                </span>
              </td>)}
            </tr>)
          })}
        </tbody>
      </table>
      </div>

      <nav>
        <ul className="pagination">
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button onClick={handleFirstPage} className="page-link">First</button>
          </li>
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button onClick={handlePrevPage} className="page-link">Prev</button>
          </li>
          {getPageNumbers().map((pageNumber) => (
            <li key={pageNumber} className={`page-item ${pageNumber === currentPage ? 'active' : ''}`}>
              <button onClick={() => handlePageChange(pageNumber)} className="page-link">
                {pageNumber}
              </button>
            </li>
          ))}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <button onClick={handleNextPage} className="page-link">Next</button>
          </li>
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <button onClick={handleLastPage} className="page-link">Last</button>
          </li>
        </ul>
      </nav>
    </div>

    <ConfirmDialog
      show={showConfirm}
      handleClose={hideDeleteConfirm}
      handleConfirm={handleDelete}
      title="Delete Company"
      message="Are you sure you want to delete this company?"/>
    </div>
  );
};

export default Companies;
